import React from 'react';
import { LessonMeta } from './types';

export interface RelatedLessonsProps {
  lessons: LessonMeta[];
  onNavigate?: (slug: string) => void;
}

// Curated mapping owned by content (AC 4.1), not derived from category/species.
// Navigation is a callback so the hub, the public page, and future embeds each
// route their own way — this package imports no router.
export default function RelatedLessons({ lessons, onNavigate }: RelatedLessonsProps) {
  if (!lessons.length) return null;
  return (
    // Not a .pc-lesson-card: the prototype leaves this section bare and makes
    // each tile its own white card.
    <section className="pc-lesson-related-section">
      <h2 className="pc-lesson-card-title">Related Lessons</h2>
      <div className="pc-lesson-related">
        {lessons.map((lesson) => (
          <button
            type="button"
            className="pc-lesson-related-card"
            key={lesson.slug}
            onClick={() => onNavigate && onNavigate(lesson.slug)}
          >
            <span className="pc-lesson-related-media">
              {lesson.cardImage && <img src={lesson.cardImage} alt="" />}
            </span>
            <span className="pc-lesson-related-body">
              <span className="pc-lesson-related-title">{lesson.title}</span>
              <span className="pc-lesson-related-summary">{lesson.cardSummary}</span>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
